if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function <T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
    const copy = this.slice();
    return copy.sort(compareFn);
  };
}
